import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExport} from "@fortawesome/free-solid-svg-icons/faFileExport";
import {assetExcelDownload} from "../../../api";
import FileExportIcon from "../../../components/FileExport/FileExportIcon";

export default (function AssetFileExport(props) {

    async function fileDownload() {
        const {projectId, station} = props;
        await assetExcelDownload(projectId, station);
    }

    return(
        <FileExportIcon props={props}
        onClick={() => fileDownload()}/>


    )

})